<main class="bookings">
  <div class="dashboard-header">
    <section class="sub-header">
      <span (click)="goBack()" class="bookings__back-arrow">
        <svg width="17" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.194 5.872H3.907l3.454-4.15A.953.953 0 1 0 5.896.505l-4.759 5.71c-.032.046-.06.094-.085.143 0 .048-.048.076-.067.124a.952.952 0 0 0-.067.343c.001.117.024.233.067.342 0 .048.048.076.067.124.025.05.053.097.085.143l4.759 5.71a.952.952 0 0 0 1.342.124.951.951 0 0 0 .123-1.342l-3.454-4.15h11.287a.952.952 0 0 0 0-1.903Z"
            fill="#2C6DA9"
          />
        </svg>
      </span>
      <h1>My Bookings</h1>
    </section>
  </div>

  <section class="main-section">
    <section class="active-bookings-section" id="my-active-booking-listview">
      <div *ngIf="getActiveBookings().length === 0" class="active-bookings--none flex-col gap-1">
        <h2 >There are no active bookings</h2>
        <a routerLink="/my-dashboard/my-requests">Check your Requests</a>
      </div>
      <div *ngIf="getActiveBookings().length != 0" class="grid-container gap-3">
        <div *ngFor="let booking of getActiveBookings();let i = index" class="grid-item">
          <app-single-booking
            [id]="i"
            [bookingInfo]="booking"
            [fees]="fees[i]"
            [limitedButtons]="false"
            (updateCreditCardDetails)="saveCreditCardInfo($event)"
            (cancelSectionToggled)="getFees($event)"
            (bookingCancelled)="cancelBooking($event)"
          >
          </app-single-booking>
        </div>
      </div>
    </section>

    <div *ngIf="getPastBookings().length != 0" class="divider-horizontal--light-blue-2"></div>

    <section class="past-bookings-section" id="my-past-booking-listview">
      <h2 *ngIf="getPastBookings().length === 0">There are no past bookings</h2>
      <div class="grid-container gap-3">
        <div *ngFor="let booking of getPastBookings()" class="grid-item">
          <app-single-booking
            [bookingInfo]="booking"
            [fees]="fees"
            [limitedButtons]="false"
            (cancelSectionToggled)="getFees($event)"
            (updateCreditCardDetails)="saveCreditCardInfo($event)"
          >
          </app-single-booking>
        </div>
      </div>
    </section>

    <div *ngIf="getCancelledBookings().length != 0" class="divider-horizontal--light-blue-2"></div>

    <section class="cancelled-bookings-section" id="my-cancelled-booking-listview">
      <h2 *ngIf="getCancelledBookings().length === 0">There are no cancelled bookings</h2>
      <div class="grid-container gap-3">
        <div *ngFor="let booking of getCancelledBookings()" class="grid-item">
          <app-single-booking
            [bookingInfo]="booking"
            [fees]="fees"
            [limitedButtons]="false"
            (cancelSectionToggled)="getFees($event)"
            (updateCreditCardDetails)="saveCreditCardInfo($event)"
            (bookingRemoved)="removeBooking($event)"
          >
          </app-single-booking>
          <!--<button (click)="removeBooking(booking)">Remove booking</button>-->
        </div>
      </div>
    </section>
  </section>
</main>
